import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';

import { IS_SERVER } from '@rpgc-ai/shared-interfaces/tokens/is-server.token';
import { WINDOW } from '@rpgc-ai/shared-interfaces/tokens/window.token';

import { filter } from 'rxjs';

import { ModalService } from '../modal/modal.service';

/** Query param, который better-auth добавляет к redirectTo из forgetPassword. */
const PASSWORD_RESET_TOKEN_QUERY = 'token';

/**
 * Открывает модалку сброса пароля, если пользователь перешёл по ссылке из письма (`?token=…`).
 */
@Injectable({ providedIn: 'root' })
export class PasswordResetDeepLinkService {
  readonly #router = inject(Router);
  readonly #modalService = inject(ModalService);
  readonly #isServer = inject(IS_SERVER);
  readonly #window = inject(WINDOW);
  readonly #destroyRef = inject(DestroyRef);

  init(): void {
    if (this.#isServer || !this.#window) {
      return;
    }

    this.#maybeOpenPasswordResetModal();

    this.#router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.#maybeOpenPasswordResetModal());
  }

  #maybeOpenPasswordResetModal(): void {
    const url = new URL(this.#router.url, `${this.#window?.location.origin}/`);
    if (!url.searchParams.has(PASSWORD_RESET_TOKEN_QUERY)) {
      return;
    }
    if (this.#modalService.getCurrentModal() === 'password-reset') {
      return;
    }
    void this.#modalService.openModal('password-reset');
  }
}
